<template>
<Menubar :model="navbarItems" class="fixed flex w-full" style="z-index:1000">
    <template #start>
        <RouterLink to="/home">
            <div class="flex flex-row align-middle">
                <img src="/images/favicon-32x32.png" style="max-height: 1.5rem;margin-right:0.5rem;"></img>
                <p>TritonX Data Portal</p>
            </div>
        </RouterLink>
    </template>
    <template #end>
        <div v-if="navbarItems.isLoggedIn" class="flex flex-row">
            <div class="flex flex-row">
                <RouterLink to="/home" class="">
                    <div class="flex flex-row align-middle">
                        <span class="p-menubar-item-icon pi pi-globe" data-pc-section="itemicon"></span>
                        <p class="pl-2 pr-4">{{ barkerAuth.getOrganization().name }}</p>
                    </div>
                </RouterLink>
            </div>
            <div class="flex flex-row">
                <RouterLink to="/account" class="">
                    <div class="flex flex-row align-middle">
                        <span class="p-menubar-item-icon pi pi-user" data-pc-section="itemicon"></span>
                        <p class="pl-2 pr-4">{{ barkerAuth.getUsername() }}</p>
                    </div>
                </RouterLink>
            </div>
        </div>
    </template>
</Menubar>
<div id="fixedNavSpacer" class="flex w-full min-h-10"></div>
</template>

<script setup>
import { inject } from 'vue'
import barkerAuth from '@/auth'

const navbarItems = inject('navbarItems')

barkerAuth.syncUserState()

</script>
